export default __webpack_public_path__ + "static/media/97_mobile.ccd132dd.jpg";